var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6 grid grid-cols-1 gap-4 h-28 max-w-sm justify-items-center bg-gray-50 border border-gray-200 rounded shadow-md text-center"},[_vm._m(0),_c('div',{staticClass:"text-sm"},[_vm._t("content")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm font-semibold"},[_c('span',[_vm._v("沒有資料")])])
}]

export { render, staticRenderFns }